import React from "react";

import { SelectList } from "@common/selectList";
import { AddMemberIcon } from "./addMemberIcon";
import { ResourceAllocationMenu } from "@common/resourceAllocationMenu";
import { ResourceAvatar } from "@common/resourceAvatar";
import { Props } from "./types";
import styles from "./styles.scss";

function RecipientInput({ recipients, input }: Props) {
  return (
    <SelectList<typeof recipients>
      listClassName={styles.list}
      rootClassName={styles.iconBox}
      inputClassName={styles.iconBox}
    >
      {() => ({
        input:
          recipients.length > 0 ? (
            <div className={styles.recipients}>
              {recipients.map((recipient) => (
                <div key={recipient.uuid} className={styles.recipient}>
                  <ResourceAvatar resource={recipient} />
                </div>
              ))}
            </div>
          ) : (
            <AddMemberIcon className={styles.icon} />
          ),
        list: (
          <ResourceAllocationMenu
            allocatedResources={recipients}
            select={(resources) => input([...recipients, ...resources])}
            unSelect={(resources) =>
              input(
                recipients.filter(
                  (recipient) =>
                    !resources.find(({ uuid }) => recipient.uuid === uuid),
                ),
              )
            }
            openedViews={["resources"]}
          />
        ),
      })}
    </SelectList>
  );
}

export { RecipientInput };
